const PrestamosLabelBox = ({
  label,
  value,
  extraValue,
}: {
  label: string
  value: string
  extraValue: string
}) => {
  return (
    <p className='tw-text-start tw-h-auto xl:tw-text-ellipsis tw-flex tw-items-center tw-flex-nowrap tw-w-full tw-truncate'>
      <span className='tw-flex tw-items-center'>
        <span className='tw-text-base'>{`${label} - `}</span>
        <span className='tw-text-alternative2'>{value}</span>
      </span>
      {extraValue && (
        <span className='tw-ml-2 tw-text-info-100 tw-max-h-12 tw-inline tw-flex-1'>
          {` ${extraValue}`}
        </span>
      )}
    </p>
  )
}

export default PrestamosLabelBox
